<template>
  <div v-resize="onResize" class="fill-height accent" ref="start-scroll-postulant">
    <v-content :fluid="$vuetify.breakpoint.lgAndDown" class="px-8 py-2 accent">
      <v-row>
        <v-col class="d-flex pb-0 flex-wrap">
          <BaseMyButtonDirection
            direction="left"
            :animate="true"
            :to="{ name: 'administrator postulants' }"
          ></BaseMyButtonDirection>
          <p class="display-2 font-weight-bold ml-4 mb-0">
            Postulaciones
            <span v-if="postulantDataFullName">de {{ postulantDataFullName }}</span>
          </p>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6">
          <BaseMyCard class="py-4" style="cursor: auto !important">
            <v-container>
              <!-- <v-row>
                <v-col class="text-center">
                  <v-icon class="error lighten-5 pa-2" style="border-radius: 50%" color="error">mdi-eye-off</v-icon>
                </v-col>
              </v-row> -->
              <v-row>
                <v-col class="text-center py-0 d-flex justify-center align-center">
                  <v-icon class="error lighten-5 pa-2 mr-4" style="border-radius: 50%" color="error">mdi-eye-off</v-icon>
                  <span class="display-2 font-weight-bold">
                    {{ totalNoReadedCurriculum }}
                  </span>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="text-center pt-0 font-weight-light grey--text text--darken-1">
                  Hoja de vida no leídas
                </v-col>
              </v-row>
            </v-container>
          </BaseMyCard>
        </v-col>
        <v-col cols="12" sm="6">
          <BaseMyCard class="py-4" style="cursor: auto !important">
            <v-container>
              <!-- <v-row>
                <v-col class="text-center">
                  <v-icon class="info lighten-5 pa-2" style="border-radius: 50%" color="info">mdi-eye</v-icon>
                </v-col>
              </v-row> -->
              <v-row>
                <v-col class="text-center py-0 d-flex justify-center align-center">
                  <v-icon class="info lighten-5 pa-2 mr-4" style="border-radius: 50%" color="info">mdi-eye</v-icon>
                  <span class="display-2 font-weight-bold">
                    {{ totalReadedCurriculum }}
                  </span>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="text-center pt-0 font-weight-light grey--text text--darken-1">
                  Hoja de vida leídas
                </v-col>
              </v-row>
            </v-container>
          </BaseMyCard>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="3">
          <BaseMyCard
            class="pa-8"
            style="cursor: auto !important"
          >
            <span class="title font-weight-bold">
              <v-icon class="mr-1">mdi-filter</v-icon>
              Filtros
            </span>
            <v-radio-group :disabled="loading" hide-details v-model="selectedFilters" column @change="applyFiter()">
              <v-radio
                v-for="(filter, index) of filters"
                :label="filter.name"
                :value="filter.value"
                on-icon="mdi-checkbox-blank-circle"
              ></v-radio>
            </v-radio-group>
          </BaseMyCard>
        </v-col>
        <v-col v-if="loading" cols="12" md="9">
          <v-progress-linear indeterminate></v-progress-linear>
          <BaseMyCard
            class="ma-2 px-5 py-4 mb-3"
            v-for="n in 2"
            :key="n"
          >
            <v-skeleton-loader
              ref="skeleton"
              type="list-item-avatar-three-line"
            ></v-skeleton-loader>
          </BaseMyCard>
        </v-col>
        <v-col v-else cols="12" md="9">
          <v-row>
            <v-col class="mx-2 pt-0 d-flex">
              <v-spacer></v-spacer>
              <span class="d-flex align-center grey--text text--darken-4 font-weight-light">
                Mostrando
                <span class="primary--text font-weight-bold mx-1">{{ itemPerPage }}</span>
                a
                <span class="primary--text font-weight-bold mx-1">{{ limitPerpage }}</span>
                de
                <span
                  class="primary--text font-weight-bold ml-1"
                >{{ total }} empleos</span>
              </span>
            </v-col>
          </v-row>
          <div v-if="jobs.length">
            <CardMyPostulation
              v-for="job in jobs"
              :key="job.id"
              :job="job"
              class="mb-3"
            ></CardMyPostulation>
          </div>
          <div v-else>
            <BaseMyCard
              class="ma-2 px-5 py-4 mb-3 d-flex align-center"
              style="cursor: auto"
            >
              <v-icon size="60" class="mr-4" color="error">mdi-card-bulleted-off-outline</v-icon>
              <span class="headline font-weight-light">No encontramos resultados</span>
            </BaseMyCard>
          </div>
          <v-pagination
            v-if="totalPages"
            v-model="page"
            :length="totalPages"
            :total-visible="6"
            @input="changePage"
          ></v-pagination>
        </v-col>
      </v-row>
    </v-content>
  </div>
</template>

<script>
import CardMyPostulation from "@/components/CardMyPostulationAdmin";
import store from "@/store";

import { windowSizeMixin } from "@/mixin/windowSizeMixin.js";

export default {
  mixins: [windowSizeMixin],
  components: {
    CardMyPostulation,
  },
  data() {
    return {
      loading: false,
      page: 1,
      limit: 10,
      total: 0,
      totalNoReadedCurriculum: 0,
      totalReadedCurriculum: 0,
      filters: [
        { name: 'Todas', value: false },
        { name: 'Leídas', value: 'leidas' },
        { name: 'No leídas', value: 'no leidas' },
        { name: 'Finalizadas', value: 'finalizadas' },
      ],
      selectedFilters: '',
      jobs: [],
      postulantData: {},
    }
  },
  computed: {
    readedCurriculum() {
      return this.jobs.filter(job => job.curriculum_leido).length;
    },
    noReadedCurriculum() {
      return this.jobs.filter(job => !job.curriculum_leido).length;
    },
    itemPerPage() {
      return this.jobs.length ? this.limit * this.page - this.limit + 1 : 0;
    },
    limitPerpage() {
      return this.jobs.length < this.limit
        ? this.total
        : this.limit * this.page;
    },
    totalPages() {
      return Math.ceil(this.total / this.limit);
    },
    postulantDataFullName() {
      if (!this.postulantData.informacion_personal) return '';
      const nombres = this.postulantData.informacion_personal ? this.postulantData.informacion_personal.nombres : '';
      const apellidos = this.postulantData.informacion_personal ? this.postulantData.informacion_personal.apellidos : '';
      return `${nombres} ${apellidos}`;
    },
  },
  created() {
    this.retrieveMyPostulations();
  },
  methods: {
    retrieveMyPostulations() {
      this.loading = true;
      const { page, limit } = this.$route.query;
      const currentPage = parseInt(page) || 1;
      const currentLimit = parseInt(limit) || 10;
      this.selectedFilters = this.$route.query.filtros || false;
      store
        .dispatch("administration/postulants/retrieveNoticesApplicant", {
          query: {
            ...this.$route.query,
            page: currentPage,
            limit: currentLimit,
          },
          postulant: this.$route.params.postulante,
        })
        .then(response => {
          this.postulantData = response.data.data;
          this.total = parseInt(response.headers['x-total-count']);
          this.jobs = response.data.resultado;
          this.page = currentPage;
          this.limit = currentLimit;
          this.totalReadedCurriculum = response.data.total_readed_curriculum;
          this.totalNoReadedCurriculum = response.data.total_no_readed_curriculum;
        })
        .catch(error => {
          // console.log(error);
          // console.log(error.response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    applyFiter() {
      this.$vuetify.goTo(this.$refs['start-scroll-postulant']);
      this.$router.push({
        name: 'administrator postulants by id',
        params: { postulante: this.$route.params.postulante },
        query: this.selectedFilters ? { filtros: this.selectedFilters } : {}
      });
      this.retrieveMyPostulations();
    },
    changePage(input) {      
      this.$vuetify.goTo(this.$refs['start-scroll-postulant']);
      this.$router.push({
        name: 'administrator postulants by id',
        params: { postulante: this.$route.params.postulante },
        query: { ...this.$route.query, page: input }
      });
      this.retrieveMyPostulations();
    },
  },
}
</script>

<style>

</style>